import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Navbar } from "./Navbar";
import { Footer } from "./PublicLayout";

export const ProtectedLayout = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-bg">
                <div className="font-heading text-2xl text-muted">Caricamento…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (!user.onboarded) return <Navigate to="/onboarding" replace />;

    return (
        <div className="min-h-screen bg-bg flex flex-col">
            <Navbar />
            <main className="container-app py-8 flex-1">{children}</main>
            <Footer />
        </div>
    );
};
